import { Modal, ModalBody, ModalHeader } from "reactstrap";

// Versão ampliada de um card de gráfico. Genérico de propósito: recebe o
// gráfico como children, então serve para os outros cards da tela sem virar
// um componente por gráfico.
export default function ChartModal({ isOpen, toggle, title, children }) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" centered>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>{children}</ModalBody>
    </Modal>
  );
}
